import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, Save } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { toast } from 'sonner';
import { adminApi, API_ENDPOINTS } from './api';

export const SettingsPanel = () => {
  const navigate = useNavigate();
  const [cur, setCur] = useState('');
  const [newU, setNewU] = useState('');
  const [newP, setNewP] = useState('');
  const [saving, setSaving] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    if (newP.length < 6) { toast.error('Mot de passe min. 6 caracteres'); return; }
    setSaving(true);
    try {
      await adminApi.put(API_ENDPOINTS.adminCredentials, {
        current_password: cur, new_username: newU, new_password: newP,
      });
      toast.success('Identifiants mis a jour !');
      sessionStorage.clear();
      setTimeout(() => navigate('/admin/login'), 1500);
    } catch (err) {
      console.error('Update credentials failed:', err);
      toast.error(err.response?.data?.detail || 'Erreur');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-lg space-y-5">
      <h1 className="text-2xl font-bold text-gray-900">Reglages</h1>
      <div className="bg-white rounded-2xl border border-gray-100 p-6" data-testid="settings-form">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 bg-gray-900 rounded-xl flex items-center justify-center">
            <Shield className="w-5 h-5 text-white" />
          </div>
          <div>
            <h3 className="font-semibold text-gray-900 text-sm">Identifiants de connexion</h3>
            <p className="text-xs text-gray-400">Modifiez votre nom d'utilisateur et mot de passe</p>
          </div>
        </div>
        <form onSubmit={save} className="space-y-4">
          <div><Label className="text-xs text-gray-500">Mot de passe actuel</Label><Input type="password" value={cur} onChange={e => setCur(e.target.value)} required className="h-10" data-testid="settings-current-pw" /></div>
          <div className="border-t border-gray-100 pt-4"><Label className="text-xs text-gray-500">Nouveau nom d'utilisateur</Label><Input value={newU} onChange={e => setNewU(e.target.value)} required className="h-10" data-testid="settings-new-user" /></div>
          <div><Label className="text-xs text-gray-500">Nouveau mot de passe</Label><Input type="password" value={newP} onChange={e => setNewP(e.target.value)} required minLength={6} className="h-10" data-testid="settings-new-pw" /></div>
          <Button type="submit" disabled={saving} className="w-full bg-gray-900 hover:bg-gray-800 h-10" data-testid="settings-save-btn">
            {saving ? 'Sauvegarde...' : <><Save className="w-4 h-4 mr-2" />Sauvegarder</>}
          </Button>
        </form>
      </div>
    </div>
  );
};
